import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MobileSubNavigator from '../../components/MobileSubNavigator';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../../AppContext';

const staticLinks = [
  // 적립금 관련 정적 링크들
];

const MobileSavings = () => {
  const { logout } = useApp();
  const location = useLocation();
  const navigate = useNavigate();
  const [links, setLinks] = useState([]);

  const checkSession = async() => {
    const user = sessionStorage.getItem('user');
    if (!user) {
      logout();
      navigate('/login');
      return false;
    }
    return true;
  };

  useEffect(() => {
    console.log('=== MobileSavings useEffect 실행됨 ===');
    // API 호출하여 테이블 이름 가져오기 (PC 버전과 동일)
    const fetchBoardTables = async () => {
      try {
        console.log('=== MobileSavings fetchBoardTables 시작 ===');
        const response = await fetch('/request/getBoardTables?category=Savings', { 
          credentials: 'include',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        });
        
        if (!response.ok) {
          console.error(`HTTP Error: ${response.status} - ${response.statusText}`);
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        console.log('받은 데이터:', data);

        // 가져온 테이블 이름을 링크로 변환
        let dynamicLinks = [];
        if (Array.isArray(data)) {
          dynamicLinks = data.map(table => ({
            path: `/Savings/Board/${table.boardId}`,
            label: table.boardTitle
          }));
        }

        console.log('생성된 동적 링크들:', dynamicLinks);
        
        if(!await checkSession()) {
          return;
        }
        
        // 정적 링크와 동적 링크 결합
        const combinedLinks = [...staticLinks, ...dynamicLinks];
        console.log('최종 combined links:', combinedLinks);
        setLinks([]);
        setTimeout(() => {
          setLinks(combinedLinks);
        }, 100);
      } catch (error) {
        console.error('Error fetching board tables:', error);
        console.log('에러 발생, staticLinks 적용:', staticLinks);
        setLinks(staticLinks);
      }
    };

    fetchBoardTables();
  }, []);

  useEffect(() => {
    if (links.length > 0) {
      if (location?.state?.fromNavigator === true) {
        navigate(links[0].path);
      }
    }
  }, [location, links, navigate]);

  
  return (
    <MobileSubNavigator 
      links={links} 
      sectionTitle="적립금 관리"
      backPath="/"
    >
      <Outlet context={{ links }} />
    </MobileSubNavigator>
  );
};

export default MobileSavings;